<template>

<div class="game">

   <core-gamename :game="item.game" class="game-name" :id="item.id" />

	<app-view-common-change 
        :date="item.rating.date" 
        :revisions="item.revisions" 
        :showDate="showDate" 
        :showChange="showStatus" 
        :datePrefix="datePrefix" 
        v-if="showStatus || showDate"
    />

    <app-view-common-tags :field="field" :item="item" :filter="filter" :is-condensed="isCondensed" v-if="showTags" />

</div>

</template>

<script>

export default {

	props: ['field', 'item', 'filter', 'isCondensed', 'isSticky'],

	computed: {

		datePrefix: function() {

			return (this.isUser || !this.item.rating.date) ? '' : 'Most recently rated on '

		},

        showTags: function() {

            return this.field.tags === 'enabled'

        },

        showStatus: function() {

            return this.field.status === 'enabled'

        },

        showDate: function() {

            return this.field.date === 'enabled' && this.isUser

        }

    }

}

</script>

<style scoped>

.game {
    padding-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

.game-name {
	color: #333;
	font-weight: 500;
	font-size: 16px;
	line-height: 16px;
	min-width: 0;
    display: block;
    max-width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    overflow: hidden;
}

.is-mobile .game-name {
	font-size: 14px;
	line-height: 14px;
}

.field.is-condensed .game-name {
	font-size: 14px;
	line-height: 14px;
}

.is-desktop .game-name:hover {
	text-decoration: underline;
}

</style>